export default __webpack_public_path__ + "static/media/aws.6ea66640.png";